import React from "react";
import ContactContent from "../FunctionComponents/ContactFolder/ContactContent";

function Contact() {
  return (
    <>
      <ContactContent />
    </>
  );
}

export default Contact;
